"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryContractDeployButton = exports.MYSTERY_CONTRACT_DEPLOY_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const deployMysteryBox_json_1 = __importDefault(require("@framework/abis/json/MysteryBoxFactoryFacet/deployMysteryBox.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const dialog_1 = require("./dialog");
exports.MYSTERY_CONTRACT_DEPLOY_DIALOG_KEY = "mysteryContractDeploy";
const MysteryContractDeployButton = props => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { chainId } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleDeploy = () => {
        openFormDialog(exports.MYSTERY_CONTRACT_DEPLOY_DIALOG_KEY, void 0, "button");
    };
    // TOKEN URI WITH CHAIN_ID
    const tokenURI = `${process.env.JSON_URL}/metadata/${chainId ? chainId.toString() : "0"}`;
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployMysteryBox_json_1.default,
            functionName: "deployMysteryBox",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    contractTemplate: Object.values(types_1.MysteryContractTemplates).indexOf(values.contractTemplate).toString(),
                    name: values.name,
                    symbol: values.symbol,
                    baseTokenURI: values.baseTokenURI,
                    royalty: BigInt(values.royalty),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/mysterybox",
            method: "POST",
            data,
        }, form);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "MysteryContractDeployButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.MysteryContractDeployDialog, { onExternalConfirm: onDeployConfirm, open: formDialogUniqueKey === `${exports.MYSTERY_CONTRACT_DEPLOY_DIALOG_KEY}.${mode}`, initialValues: {
                    contractTemplate: types_1.MysteryContractTemplates.SIMPLE,
                    name: "",
                    symbol: "",
                    baseTokenURI: tokenURI,
                    royalty: 0,
                } })] }));
};
exports.MysteryContractDeployButton = MysteryContractDeployButton;
//# sourceMappingURL=index.js.map